/** @clearscore/helpers.add-url-variables v1.17.8: 2022-12-12 17:54 (assemble v5.5.1) **/
import hasClientData from '@clearscore/helpers.has-client-data';
import { resolveProp } from '@clearscore/helpers.resolve-props';

/* eslint-disable no-useless-escape */
/**
 * Predicate to evaluate if given value is a string beginning with @
 * @param {string} val to check
 * @returns {boolean} if item is object
 */

var _shouldLookupProperty = function _shouldLookupProperty(val) {
  return typeof val === 'string' && val.startsWith('@');
};
/**
 * Look through given url string and attempt to resolve any values beginning with @ from given context
 * @param {Object} context state to resolve values from
 * @param {string} urlString url string
 * @returns {string} URL with values interpolated
 */

var interpolateValues = function interpolateValues(context) {
  var urlString = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var interpolatedUrlString = urlString;
  function _resolveProp(prefixedPath) {
    var isOptionalProp = prefixedPath.startsWith('?@');
    var prefixLength = isOptionalProp ? 2 : 1;
    var resolvedProp = resolveProp(prefixedPath.substring(prefixLength), context);
    if (!resolvedProp) {
      return isOptionalProp ? null : prefixedPath;
    }
    return resolvedProp;
  }
  var matches = interpolatedUrlString.match(/(@.[^\/]*)/);
  if (matches && matches.length) {
    matches.forEach(function (match) {
      var resolvedProp = _shouldLookupProperty(match) ? _resolveProp(match) : match;
      interpolatedUrlString = resolvedProp ? interpolatedUrlString.replace(match, resolvedProp) : interpolatedUrlString;
    });
  }
  return interpolatedUrlString;
};

/**
 * check for url property and replace common variables
 * @param {object} action redux action
 * @param {object} store redux store
 * @returns {object} action redux action
 */

function _addVariables(action, store) {
  var request = action.payload.request;
  var state = store.getState();
  if (request.url) {
    request.url = interpolateValues(state, request.url);
  }
  return action;
}
/**
 * If the action payload has a client object, check and replace common variables.
 * @param {object} action redux action
 * @param {object} store redux store
 * @returns {function} function that takes an action and returns an action
 */

var addUrlVariables = function addUrlVariables(store) {
  return function (action) {
    return hasClientData(action) ? _addVariables(action, store) : action;
  };
};
export { addUrlVariables as default };